import React, { useEffect, useState } from 'react';
import {
  Paper,
  Typography,
  makeStyles,
  Divider,
  CardContent,
  Card,
  Grid,
  Container,
  Box,
  Button
} from '@material-ui/core';
import { useParams, useNavigate } from 'react-router-dom'; // Use useParams and useNavigate
import axios from 'axios';
import ReactMarkdown from 'react-markdown';
import WorkOutlineIcon from '@material-ui/icons/WorkOutline';
import DescriptionOutlinedIcon from '@material-ui/icons/Description';
import WorkIcon from '@material-ui/icons/Work';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import TodayIcon from '@material-ui/icons/Today';
import { useRequest } from 'src/hooks';
import { useSelector } from 'react-redux';

const useStyles = makeStyles(theme => ({
  topCard: {
    padding: '35px',
    // width: '100%',
    height: '150px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    borderRadius: '0px',
    backgroundColor: '#f57c00',
    color: '#fff',
    textAlign: 'center'
  },
  title: {
    fontWeight: 900,
    fontSize: '4rem',
    [theme.breakpoints.down('md')]: {
      fontSize: '3rem', // mid screen
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '2rem', // small screen
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.75rem', // extra small screen
    },
    color: '#ffffff',
    paddingTop: '20px',
    marginBottom: theme.spacing(1)
  },
  sectionCard: {
    padding: theme.spacing(4),
    maxWidth: '100%',
    boxShadow: '0 6px 16px rgba(0,0,0,0.1)',
    borderRadius: '8px',
    backgroundColor: '#ffffff'
  },

  sectionHeader: {
    display: 'flex',
    alignItems: 'center',
    fontWeight: 700,
    fontSize: '1.5rem',
    color: '#f57c00',
    marginBottom: theme.spacing(2)
  },
  sectionHeaderIcon: {
    marginRight: theme.spacing(1),
    color: '#f57c00'
  },
  sectionContent: {
    fontSize: '1rem',
    color: '#333',
    lineHeight: 1.8
  },
  jobDetailRow: {
    display: 'flex',
    justifyContent: 'flex-start',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(1),
    padding: theme.spacing(0.5, 0)
  },
  whiteBackground: {
    backgroundColor: '#ffffff'
  }
}));

const JobDetailsPublic = () => {
  const classes = useStyles();
  const { ixJob } = useParams();
  const request = useRequest();
  const {
    portal: { token }
  } = useSelector(({ auth }) => auth);

  const [job, setJob] = useState(null);
  const [salary, setSalary] = useState('N/A');
  const [typeOfWork, setTypeOfWork] = useState('N/A');
  // const [company, setCompany] = useState('');
  // const [markdown, setMarkdown] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [jobsMeta, setJobsMeta] = useState(null);

  const fetchJobDetails = async () => {
    try {
      const response = await axios.get(`/api/jobs/meta`);
      setJobsMeta(response.data);
    } catch (err) {
      console.error('Error fetching job details:', err);
    }

    if (!ixJob) {
      setError('Job ID is missing.');
      return;
    }

    try {
      const response = await axios.get(`/api/jobs/item/${ixJob}/public`, {
        headers: {
          'x-access-tokens': token,
          'Content-Type': 'application/json'
        }
      });

      if (response.data) {
        const jobData = response.data;
        setJob(jobData);

        const kvs = jobData.kvs || [];
        const salaryData = kvs.find(item => item.key === 'salary');
        const typeOfWorkData = kvs.find(item => item.key === 'typeOfWork');
        // const companyData = kvs.find(item => item.key === 'company');

        setSalary(salaryData ? salaryData.value : 'N/A');
        setTypeOfWork(typeOfWorkData ? typeOfWorkData.value : 'N/A');
        // setCompany(companyData ? companyData.value : '')
        // setMarkdown(
        //   jobData.markdown?.value || 'Login or register to view more details.'
        // );
      } else {
        setError('No job details found.');
      }
    } catch (err) {
      console.error('Error fetching job details:', err);
      setError('Failed to fetch job details.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (ixJob) fetchJobDetails();
    else {
      setError('Job ID is missing.');
      setLoading(false);
    }
  }, [ixJob, token]);

  if (error) {
    return (
      <Typography align="center" color="error">
        {error}
      </Typography>
    );
  }

  if (!job) {
    return <Typography align="center"> </Typography>;
  }

  const handleRegister = () => {
    const {
      jobs: { app_ixJCd }
    } = jobsMeta;

    // const applyURL = token
    //   ? `/portal/trans/${app_ixJCd}/new?ixJob=${ixJob}`
    //   : `/registration?ixJob=${ixJob}`;
    const applyURL = `/registration?ixJob=${ixJob}`;
    window.open(applyURL, '_blank');
  };
  const handleBackClick = () => {
    window.history.back();
  };
  const handleLoginClick = () => {
    window.location.href = `/portal/${jobsMeta?.jobs?.cdBiz}/${jobsMeta?.jobs?.cdPortal}/login`
  }

  return (
    <Box
      style={{ marginTop: 0, padding: 0, paddingBottom: '30px' }}
      className={classes.whiteBackground}
    >
      <Box className={classes.topCard}>
        <Typography className={classes.title}>{job.Name || 'N/A'}</Typography>
      </Box>

      <Container>
        <Grid
          container
          spacing={2}
          style={{ marginTop: '20px', marginBottom: '20px' }}
        >
          <Grid
            container
            spacing={2}
            style={{ marginTop: '20px' }}
            alignItems="stretch"
          >
            <Grid
              item
              lg={8}
              md={8}
              xs={12}
              style={{ display: 'flex', flexDirection: 'column' }}
            >
              <Paper className={classes.sectionCard} style={{ flexGrow: 1 }}>
                <Typography className={classes.sectionHeader}>
                  <WorkOutlineIcon className={classes.sectionHeaderIcon} />
                  Job Overview
                </Typography>

                <Divider className={classes.divider} />
                <div className={classes.jobDetailRow}>
                  <Typography variant="body1">
                    <b>Particulars: </b> {job.Particulars || 'N/A'}
                  </Typography>
                </div>
                <div className={classes.jobDetailRow}>
                  <Typography variant="body1">
                    Company: Login to view.
                  </Typography>
                </div>
              </Paper>
            </Grid>
            <Grid
              item
              lg={4}
              md={4}
              xs={12}
              style={{ display: 'flex', flexDirection: 'column' }}
            >
              <Paper className={classes.sectionCard} style={{ flexGrow: 1 }}>
                <Box
                  display="flex"
                  alignItems="center"
                  style={{ marginBottom: '16px' }}
                >
                  <WorkIcon color="primary" fontSize="large" />
                  <Typography variant="body1" style={{ marginLeft: '8px' }}>
                    TYPE OF WORK: <b>{typeOfWork}</b>
                  </Typography>
                </Box>
                <Box
                  display="flex"
                  alignItems="center"
                  style={{ marginBottom: '16px' }}
                >
                  <MonetizationOnIcon color="primary" fontSize="large" />
                  <Typography
                    variant="body1"
                    color="gray"
                    style={{ marginLeft: '8px' }}
                  >
                    SALARY:{' '} 
                    <b>{salary}</b>
                  </Typography>
                </Box>
                <Box display="flex" alignItems="center">
                  <TodayIcon color="primary" fontSize="large" />
                  <Typography
                    variant="body1"
                    color="gray"
                    style={{ marginLeft: '8px' }}
                  >
                    DATE POSTED:{' '}<b>
                    {new Date(job.jDate).toLocaleDateString('en-US', {
                      month: 'long',
                      day: 'numeric',
                      year: 'numeric'
                    })}</b>
                  </Typography>
                </Box>
              </Paper>
            </Grid>
          </Grid>
          <Grid
            container
          >

        <Paper className={classes.sectionCard} style={{ flexGrow: 1, marginTop: '20px'}}>
          <Typography className={classes.sectionHeader}>
            <DescriptionOutlinedIcon className={classes.sectionHeaderIcon} />
            Job Details
          </Typography>
          <Divider className={classes.divider} />
          <Typography className={classes.sectionContent}>
            <ReactMarkdown>Login for more details...</ReactMarkdown>
          </Typography>
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <button
              onClick={handleBackClick}
              variant="contained"
              size="large"
              color="secondary"
              style={{
                backgroundColor: 'gray',
                color: '#fff',
                padding: '10px 20px',
                border: 'none',
                borderRadius: '5px',
                marginRight: '5px',
                cursor: 'pointer',
                fontSize: '20px'
              }}
            >
              Back
            </button> 
            <button
              onClick={handleLoginClick}
              variant="contained"
              size="large"
              color="secondary"
              style={{
                backgroundColor: 'gray',
                color: '#fff',
                padding: '10px 20px',
                border: 'none',
                borderRadius: '5px',
                marginRight: '5px',
                cursor: 'pointer',
                fontSize: '20px'
              }}
            >
              Login
            </button> 
            <button
              onClick={handleRegister}
              variant="contained"
              size="large"
              color="primary"
              style={{
                backgroundColor: '#f57c00',
                color: '#fff',
                padding: '10px 20px',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                fontSize: '20px'
              }}
            >
              Register
            </button>
          </div>
        </Paper>
        </Grid>
        </Grid>

      </Container>
    </Box>
  );
};

export default JobDetailsPublic;
